export const isPdfUrl = (url?: string | null): boolean => {
    if (!url || typeof url !== 'string') return false;

    const normalized = url.split('#')[0].split('?')[0];
    return normalized.toLowerCase().endsWith('.pdf');
};
